import { getAPI } from "./Common";

const GetCountUnreadNotification = async () => {
  let response = await getAPI(
    "/api/Notification/GetUnReadNotificationCountOfSuperAdmin"
  );
  // console.log("response", response.data);

  return response?.data;
};

export default GetCountUnreadNotification;
